import { render, staticRenderFns } from "./RichTextBoxPropertyEditor.vue?vue&type=template&id=5a247988&scoped=true&"
import script from "./RichTextBoxPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./RichTextBoxPropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a247988",
  null
  
)

export default component.exports